import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-task-file-contents',
  templateUrl: './task-file-contents.component.html',
  styleUrls: ['./task-file-contents.component.scss']
})
export class TaskFileContentsComponent {
  @Input() public taskContent!: string;

  public getViewHeight(): number {
    const element = document.getElementById('task-details-header-container');
    if (!element){
      return window.innerHeight / 2;
    }

    return window.innerHeight - element.offsetHeight - 330;
  }
}
